module.exports = __webpack_public_path__ + "static/media/UPL.d594960e.txt";